<template>
  <v-card>
    <v-card-text>
      <ErrorsMessages :errors="errors" />
      <b-row>
        <b-col cols="auto">
          <h5>
            {{ period.rest_home_name }}
          </h5>
        </b-col>
        <b-col>
          <b-badge :variant="period.payment_status_level">
            {{ period.payment_status_name }}
          </b-badge>
        </b-col>
        <b-col cols="auto">
          <h5>{{ formatBRLCurrency(period.payment_value) }}</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Ano">
            <b-select v-model="year" @change="yearChange">
              <b-select-option v-for="y in p_years" :key="y" :value="y">
                {{ y }}
              </b-select-option>
            </b-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Mês">
            <b-select v-model="month" @change="monthChange">
              <b-select-option
                v-for="item in p_months"
                :value="item"
                :key="item"
              >
                {{ months[item].name }}
              </b-select-option>
            </b-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Período">
            <b-select v-model="charge_period" @change="getPeriod">
              <b-select-option
                v-for="item in p_periods"
                :value="item.id"
                :key="item.id"
              >
                {{ padding(new Date(item.period_start).getDate()) }}-{{
                  new Date(item.period_end).toLocaleDateString()
                }}
              </b-select-option>
            </b-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="auto">
          <span>{{ period.residents.length }} residentes</span>
        </b-col>
        <b-col cols="auto">
          <span>Período: {{ period_span }}</span>
        </b-col>
        <b-col cols="auto">
          <span>Pagamento: {{ payment_span }}</span>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn class="v-danger ml-1" @click="setStatus('blocked')">
            <i class="fa fa-close mr-1"></i> BLOQUEADO
          </v-btn>
          <v-btn class="v-warning ml-1" @click="setStatus('late')">
            <i class="fa fa-check mr-1"></i> ATRASADO
          </v-btn>
          <v-btn class="v-secondary ml-1" @click="setStatus('exempted')">
            <i class="fa fa-check mr-1"></i> ISENTO
          </v-btn>
          <v-btn class="v-secondary ml-1" @click="setStatus('open')">
            <i class="fa fa-check mr-1"></i> ABERTO
          </v-btn>
          <v-btn class="v-primary ml-1" @click="setStatus('pending')">
            <i class="fa fa-check mr-1"></i> FECHADO
          </v-btn>
          <v-btn class="v-success ml-1" @click="setStatus('paid')">
            <i class="fa fa-check mr-1"></i> PAGO
          </v-btn>
          <v-btn
            class="v-primary ml-1"
            @click="
              $router.push({
                name: 'print-charge',
                params: { rest_home_id, charge_period },
              })
            "
          >
            <i class="fa fa-print mr-1" /> IMPRIMIR
          </v-btn>
        </b-col>
      </b-row>
      <hr v-if="false" />
      <b-row v-if="false">
        <b-col>
          <b-form-group label="PLANOS">
            <v-data-iterator :items="period.plans">
              <template #default="{ items }">
                <v-list dense>
                  <v-list-group
                    no-action
                    v-for="plan in items"
                    :key="`plan-${plan.id}`"
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ plan.description }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-group
                      sub-group
                      no-action
                      v-for="day of plan.days"
                      :key="`plan-${plan.id}-day-${day.id}`"
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ new Date(day.date).toLocaleDateString() }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            R${{ day.standard_value }} (min: R${{
                              day.start_value
                            }})
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>

                      <v-list-item v-for="mod in day.modules" :key="mod.id">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ mod.description }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            R${{ mod.standard_value }} (min: R${{
                              mod.start_value
                            }})
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list-group>
                </v-list>
              </template>
            </v-data-iterator>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-if="period.residents.length > 0">
        <hr />
        <b-row>
          <b-col>
            <b-form-group
              :label="`${period.residents.length} ${
                period.residents.length == 1
                  ? 'residente ativo'
                  : 'residentes ativos'
              }`"
            >
              <v-data-table
                dense
                :headers="active_resident_headers"
                :items="period.residents"
                :footer-props="{
                  'items-per-page-options': [100, 200, 300],
                  'items-per-page-text': 'Mostrar',
                }"
              >
                <template #[`item.start_date`]="{ item }">
                  {{ formatDate(item.start_date, false) }}
                </template>
                <template #[`item.end_date`]="{ item }">
                  {{ formatDate(item.end_date, false) }}
                </template>
                <template #[`item.days`]="{ item }">
                  {{ item.days.length }}
                </template>
                <template #[`item.total`]="{ item }">
                  {{ formatBRLCurrency(item.total) }}
                </template>
              </v-data-table>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";

import { dialogConfirm, formatBRLCurrency } from "../../lib/functions";

import api from "../../services/api";

import toast from "../../components/ToastNotification";

import { formatDate } from "../../functions/format";

export default {
  name: "RestHomeCharge",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      tab: null,

      errors: [],

      loading: false,
      periods: {},
      p_years: [],
      p_months: [],
      p_periods: [],

      period: {
        residents: [],
        end: "",
        force_charge_per_resident: "",
        payment_date_end: "",
        payment_date_start: "",
        payment_status_id: "",
        payment_status_level: "",
        payment_status_message: "",
        payment_status_name: "",
        payment_status_value: "",
        payment_term_value: "",
        payment_value: "",
        plans: [],
        rest_home_id: "",
        rest_home_name: "",
        start: "",
      },

      years: [],
      year: null,

      months: [
        { name: "JANEIRO", value: 0 },
        { name: "FEVEREIRO", value: 1 },
        { name: "MARÇO", value: 2 },
        { name: "ABRIL", value: 3 },
        { name: "MAIO", value: 4 },
        { name: "JUNHO", value: 5 },
        { name: "JULHO", value: 6 },
        { name: "AGOSTO", value: 7 },
        { name: "SETEMBRO", value: 8 },
        { name: "OUTUBRO", value: 9 },
        { name: "NOVEMBRO", value: 10 },
        { name: "DEZEMBRO", value: 11 },
      ],

      month: 1,
      charge_period: 1,
      period_span: null,
      payment_span: null,

      rest_home_id: "",

      active_resident_headers: [
        { text: "Nome", value: "name" },
        { text: "Data inicial", value: "start_date" },
        { text: "Data final", value: "end_date" },
        { text: "Dias ativos", value: "days" },
        { text: "Valor", value: "total" },
      ],
    };
  },
  created() {
    const { id } = this.$attrs;

    this.rest_home_id = id;

    this.retrieve();
  },
  methods: {
    formatBRLCurrency,
    formatDate,
    dialogConfirm,

    async retrieve() {
      try {
        await this.getPeriods();
        await this.getPeriod();
      } catch (error) {
        console.log(error);
      }
    },

    async getPeriods() {
      try {
        this.loading = true;

        let params = { rest_home_id: this.rest_home_id };
        let response = await api.get("/admin/rest-home/charge/periods", {
          params,
        });
        let { error, errors, periods } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.periods = periods;

          this.p_years = Object.keys(this.periods);
          this.year = this.p_years[this.p_years.length - 1];

          this.p_months = Object.keys(this.periods[this.year]);
          this.month = this.p_months[this.p_months.length - 1];

          this.p_periods = this.periods[this.year][this.month];
          this.charge_period = this.p_periods[this.p_periods.length - 1].id;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async yearChange() {
      this.p_months = Object.keys(this.periods[this.year]);
      this.month = this.p_months[this.p_months.length - 1];
      await this.monthChange();
    },

    async monthChange() {
      this.p_periods = this.periods[this.year][this.month];
      this.charge_period = this.p_periods[this.p_periods.length - 1].id;
      await this.getPeriod();
    },

    async getPeriod() {
      try {
        this.loading = true;

        let params = {
          rest_home_id: this.rest_home_id,
          charge_period: this.charge_period,
        };
        let response = await api.get("/admin/rest-home/charge/period", {
          params,
        });
        let { error, errors, period } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.period = period;
          this.period.start = new Date(this.period.start);
          this.period.end = new Date(this.period.end);
          this.period.payment_date_start = new Date(
            this.period.payment_date_start
          );
          this.period.payment_date_end = new Date(this.period.payment_date_end);

          this.period_span = this.padding(this.period.start.getDate()) + "-";
          this.period_span += this.period.end.toLocaleDateString();

          this.payment_span =
            this.padding(this.period.payment_date_start.getDate()) + "-";
          this.payment_span +=
            this.period.payment_date_end.toLocaleDateString();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async setStatus(status) {
      try {
        this.loading = true;

        let data = { period_id: this.period.payment_status_id };
        let response = await api.patch(`/payment-term/set-${status}`, data);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          await this.getPeriod();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    padding(n) {
      return n < 10 ? `0${n}` : String(n);
    },
  },
};
</script>